// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".eos-app__toolbar[data-v-6bc84fdf]{border-bottom:1px solid #eee}.eos-app__name[data-v-6bc84fdf]{width:50%}", ""]);
// Exports
module.exports = exports;
